import type { ReactNode } from 'react';

/** Мелкие элементы форм онбординга в токенах проекта (ТЗ п.14.1: только существующие стили). */
export function Field({ label, children, hint, className = '' }: { label: string; children: ReactNode; hint?: string; className?: string }) {
  return (
    <label className={`block min-w-0 ${className}`}>
      <span className="mb-1 block text-[11px] font-medium text-foreground-600">{label}</span>
      {children}
      {hint && <span className="mt-1 block text-[10.5px] leading-4 text-foreground-400">{hint}</span>}
    </label>
  );
}

export function Section({ title, children, action }: { title: string; children: ReactNode; action?: ReactNode }) {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-sm font-semibold text-foreground-950">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
